import type { MergeInput, MergeResponseV1 } from "../merge/types";

export interface MergeWorkerRequest {
  readonly type: "merge";
  readonly id: number;
  readonly input: MergeInput;
}

export type MergeWorkerReply =
  | {
      readonly type: "result";
      readonly id: number;
      readonly raw: string;
      readonly response: MergeResponseV1;
    }
  | {
      readonly type: "failure";
      readonly id: number;
      readonly message: string;
    };

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function isMergeResponse(value: unknown): value is MergeResponseV1 {
  if (!isRecord(value)) {
    return false;
  }

  if (
    value.schema !== "libdualnative-merge-response-v1" ||
    value.engine !== "libdualnative-core-v1" ||
    value.domain !== "libdualnative-json-merge-binary64-array-free-v1"
  ) {
    return false;
  }

  return (
    value.status === "merged" ||
    value.status === "conflict" ||
    value.status === "invalid_input" ||
    value.status === "unsupported" ||
    value.status === "resource_limit"
  );
}

export function isWorkerReply(value: unknown): value is MergeWorkerReply {
  if (!isRecord(value) || typeof value.id !== "number") {
    return false;
  }

  if (value.type === "failure") {
    return typeof value.message === "string";
  }

  return (
    value.type === "result" &&
    typeof value.raw === "string" &&
    isMergeResponse(value.response)
  );
}

